export enum ModalStatusEnum {
    CLOSED = "closed",
    CLOSING = "closing",
    OPENED = "opened",
    OPENING = "opening"
}

export type ModalTransitionStatusType =
    | string
    | ModalStatusEnum.CLOSED
    | ModalStatusEnum.CLOSING
    | ModalStatusEnum.OPENED
    | ModalStatusEnum.OPENING;
